import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed } from 'vue';
    import { VatSubmission } from '@/types';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import SubmitVat from './SubmitVat.vue';
    import EditVat from './EditVat.vue';
    import type { Table, Row } from '@tanstack/vue-table';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VatTableActions',
  props: {
    vatSubmission: {},
    row: {},
    table: {}
  },
  setup(__props: any) {

    const props = __props;

    const isDeadlinePassed = computed(() => {
        if (!props.vatSubmission.deadline) {
            return false;
        }

        const deadline = new Date(props.vatSubmission.deadline);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        deadline.setHours(0, 0, 0, 0);

        return deadline < today;
    });

    const canEdit = computed(() => {
        return (
            !isDeadlinePassed.value &&
            props.vatSubmission.status === 'submitted' &&
            !props.vatSubmission._is_editing
        );
    });

    const canSubmit = computed(() => {
        return (
            !isDeadlinePassed.value &&
            (props.vatSubmission.status === 'draft' || props.vatSubmission._is_editing)
        );
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.vatSubmission }, {
    default: _withCtx(() => [
      (canEdit.value)
        ? (_openBlock(), _createBlock(EditVat, {
            key: 0,
            table: _ctx.table,
            row: _ctx.row
          }, null, 8, ["table", "row"]))
        : _createCommentVNode("", true),
      (canSubmit.value)
        ? (_openBlock(), _createBlock(SubmitVat, {
            key: 1,
            "vat-submission": _ctx.vatSubmission
          }, null, 8, ["vat-submission"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})